// ~/plugins/truncate.js
export default defineNuxtPlugin((nuxtApp) => {
    const app = nuxtApp.vueApp;
    if (!app._context.directives.truncate) {
        app.directive('truncate', {
            mounted(el, binding) {
                const originalText = el.innerText.trim();
                const wordLimit = Number(binding.value) || 30;
                let isTruncated = true;

                // grab $t from either nuxt-i18n or a global mixin
                const t = (key) => (binding.instance && binding.instance.$t ? binding.instance.$t(key) : key);

                function updateText() {
                    const words = originalText.split(/\s+/);
                    if (!isTruncated || words.length <= wordLimit) {
                        // show full text (+ “show less” if we ever truncated)
                        el.innerHTML = originalText +
                            (words.length > wordLimit
                                ? ` <a href="#" class="show-less">${t('General|showLess')}</a>`
                                : '');
                    } else {
                        // truncated view
                        const truncated = words.slice(0, wordLimit).join(' ');
                        const ellipsed = truncated + '…';
                        const remaining = originalText.slice(truncated.length);
                        if (remaining.length > 20) {
                            el.innerHTML = `${ellipsed} <a href="#" class="show-more">${t('General|showMore')}</a>`;
                        } else {
                            el.innerText = originalText;
                        }
                    }
                }

                el.__truncateUpdate__ = updateText;
                updateText();

                const listener = (e) => {
                    const tgt = e.target;
                    if (tgt.matches('.show-more') || tgt.matches('.show-less')) {
                        e.preventDefault();
                        isTruncated = !isTruncated;
                        updateText();
                    }
                };
                el.addEventListener('click', listener);
                el.__truncateListener__ = listener;
            },

            beforeUnmount(el) {
                if (el.__truncateListener__) {
                    el.removeEventListener('click', el.__truncateListener__);
                    delete el.__truncateListener__;
                }
                delete el.__truncateUpdate__;
            }
        });
    }

});